import {
  EServiceType,
  ICheckPublishTermSchema,
} from '../../../../repositories/billing-tariffs/entities/PublishTerms/CheckPublishTermSchema';
import { IServicePeriod } from '../../../../types/reducers/publishTerms';

interface IMapCalltrackingTermParams {
  period: IServicePeriod;
}

export function mapCalltrackingTerm(params: IMapCalltrackingTermParams): ICheckPublishTermSchema {
  const {
    period: { type, days, tariffIdentificator, token },
  } = params;

  return {
    type,
    days,
    services: [EServiceType.calltracking],
    tariffIdentificator,
    token,
  };
}
